import { FootprintsScreen } from "../../features/footprints";

/** FS-10 나의 발자취 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/footprints */
export default function FootprintsPage() {
  return <FootprintsScreen />;
}
